import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { UNIVERSAL_URL_PATH } from '@spotMobileConfig';
import { setupStore } from './store';
import App from './views/App';

ReactDOM.render(
  <Provider store={setupStore()}>
    <Router>
      <div>
        <Route exact path="/" component={App} />
        <Route exact path={UNIVERSAL_URL_PATH} component={App} />
      </div>
    </Router>
  </Provider>,
  document.getElementById('root')
);
